export default {
  BPCookieDomain: '',

  captchaSiteKey: '6Lf5ECkTAAAAAC3DL7-_vFKqEWLi57HFkmr4MvGS',

  citrusApiUrl: 'https://integration.ocado.citrusad.co/v1',

  dynamicYieldSiteId: '9878322',
  dynamicYieldApiKey: '1a5562a34f0a62ba1c92ed6e1c3b851c6dfb02a9fbd2c53ee20852c1a7468893',

  facebookUrlToLike: 'https://www.facebook.com/Ocado',
  facebookAppId: '127309654003399',

  gtmId: 'GTM-BLHQ',
  queueItCustomer: 'ocado',
  queueItKey: 'a1ca5691-ecdc-4a8a-87e5-dd0fd865ca43aa941f12-2d11-4f19-ae48-7444cecdbb6a',

  sentryDSNPublic: 'https://f8b972551c2a2b7dbf84decaf000b3fa@o1146722.ingest.us.sentry.io/4504327972257793',
  sentryWhitelistUrls: [
    /(.*)\.ocado\.com/,
  ],

  ssoAllowedUrlOverriding: false,
  ssoTargetOrigin: 'https://accounts.ocado.com',
  ospUrl: 'https://ww2.ocado.com/login',
  isProduction: true,

  fmApiUrl: 'https://lwi-prd.foodmaestro.me/api/v3/',
};
